import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useErrorToast } from './queryUtils';
import {
  fetchLabelProjectMappings,
  upsertLabelProjectMapping,
  deleteLabelProjectMapping,
} from '../services/api/leadLabelMappings';

export function useLabelProjectMappings() {
  return useQuery({
    queryKey: ['label-project-mappings'],
    queryFn: fetchLabelProjectMappings,
  });
}

export function useUpsertLabelProjectMapping() {
  const queryClient = useQueryClient();
  const onError = useErrorToast();
  return useMutation({
    mutationFn: ({ labelId, projectId }: { labelId: number | null; projectId: number }) =>
      upsertLabelProjectMapping(labelId, projectId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['label-project-mappings'] });
    },
    onError: (err) => onError(err, "Couldn't save mapping"),
  });
}

export function useDeleteLabelProjectMapping() {
  const queryClient = useQueryClient();
  const onError = useErrorToast();
  return useMutation({
    mutationFn: (labelId: number | null) => deleteLabelProjectMapping(labelId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['label-project-mappings'] });
    },
    onError: (err) => onError(err, "Couldn't clear mapping"),
  });
}
